// i18next-Initialisierung. DE ist Default + Fallback. EN-Bundle
// liegt parat aber leer (nur Schlüssel) -- Strings kommen wenn
// echtes EN-Launch fällig wird.
//
// Auto-Detection: localStorage ('predfuture_lang') > navigator.language > 'de'.
// Browser-Default wäre für deutsche User meistens 'de' -- aber
// wenn jemand sein OS auf EN hat und in DE-Beta einsteigt, soll
// er trotzdem DE sehen. Deshalb: detector liest priorisiert
// localStorage, ignoriert navigator.

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import de from './locales/de.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
    },
    fallbackLng: 'de',
    supportedLngs: ['de', 'en'],
    interpolation: {
      escapeValue: false, // React escaped schon
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'predfuture_lang',
      caches: ['localStorage'],
    },
    // Während der DE-only-Beta: wenn ein Key in DE noch nicht
    // existiert, render keine Stelle aus dem EN-Bundle (EN ist
    // sowieso leer). Fallback bleibt aber definiert für späteren
    // Multi-Lang-Switch.
    returnEmptyString: false,
  });

export default i18n;
